import { Button } from '@shared/components/shadcn';
import { twMerge } from '@shared/themes';
import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import type { ComponentProps } from 'react';
import { ThemeAwareImage } from '../../Footer/components/ThemeAwareImage';
import { DEFAULT_IMAGES } from './constants';

type SaferGamblingImage = {
  src: string | { light: string; dark: string };
  href: string;
  alt: string;
  trackName: string;
  width: number;
  height: number;
  className?: string;
};

type HomePageSaferGamblingProps = ComponentProps<'div'> & {
  namespace: string;
  images?: SaferGamblingImage[];
  ctaHref?: string;
};

function HomePageSaferGambling({
  namespace,
  className,
  images = DEFAULT_IMAGES,
  ctaHref = ROUTES.FOOTER.NAVIGATION.GAMBLE_SAFELY.GAMBLE_SAFELY,
  ...props
}: HomePageSaferGamblingProps) {
  const t = useTranslations(namespace);

  return (
    <div className={twMerge(className, 'll-grid-container')} data-track-container="Discover Safety" {...props}>
      <div className="ll-container-inner flex flex-col items-center text-center">
        <h3 className="mb-2">{t('title')}</h3>
        <p>{t('description')}</p>
      </div>
      <div className="ll-container-full overflow-x-auto my-1 text-center hide-scrollbar">
        <div className="inline-flex items-center gap-4" data-track-container="Gamble Responsibly">
          {images.map(image => (
            <Link key={image.trackName} href={image.href} target="_blank" rel="noopener" data-track-name={image.trackName} className="flex-shrink-0">
              <ThemeAwareImage className={image.className} src={image.src} alt={image.alt} width={image.width} height={image.height} />
            </Link>
          ))}
        </div>
      </div>

      <div className="ll-container-inner flex justify-center">
        <Button variant="secondary" size="l" className="md:hidden" asChild data-track-name="More info">
          <Link href={ctaHref}>{t('cta')}</Link>
        </Button>
        <Button variant="secondary" size="m" className="hidden md:inline-flex" asChild data-track-name="More info">
          <Link href={ctaHref}>{t('cta')}</Link>
        </Button>
      </div>
    </div>
  );
}

export { HomePageSaferGambling };
export type { SaferGamblingImage };
